import type { TimeRange } from "../../app/state/view/timeline/TimeRange";
import type { DashboardWidgetSpec } from "../../common/dashboard-spec";

import { FormState } from "./_form-state";

export interface SetupDashboardWidgetDrawerState {
	id?: string;

	type: "create" | "edit";
	timeRange: TimeRange;
	form: FormState;
	onSave: (value: DashboardWidgetSpec) => void;
}

export type InitCreateDashboardWidgetDrawerStateParams = Pick<
	SetupDashboardWidgetDrawerState,
	"id" | "timeRange" | "onSave"
>;

export function initCreateDashboardWidgetDrawerState(
	params: InitCreateDashboardWidgetDrawerStateParams,
): SetupDashboardWidgetDrawerState {
	return {
		...params,
		type: "create",
		form: FormState.init(),
	};
}

export interface InitEditDashboardWidgetDrawerStateParams
	extends Pick<SetupDashboardWidgetDrawerState, "id" | "timeRange" | "onSave"> {
	widget: DashboardWidgetSpec;
}

export function initEditDashboardWidgetDrawerState({
	widget,
	...params
}: InitEditDashboardWidgetDrawerStateParams): SetupDashboardWidgetDrawerState {
	return {
		...params,
		type: "edit",
		form: FormState.init(FormState.specToInput(widget)),
	};
}
